import {Provider} from 'react-redux';
import App from './defaults.js';
import {applicationStore} from './store/index.js';

const Defaults = () => (
  <Provider store={applicationStore}>
    <App />
  </Provider>
);

export default Defaults;
